import React from "react";

interface ChevronUpDoubleIconProps {
  color?: string;
  className?: string;
}

const ChevronUpDoubleIcon: React.FC<ChevronUpDoubleIconProps> = ({
  color = "#24AEA8",
  className,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_chevron_double)">
        <path
          d="M3.75 15.625L10 9.375L16.25 15.625"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 9.375L10 3.125L16.25 9.375"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_chevron_double">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ChevronUpDoubleIcon;
